import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const BannerTemplateDetails = lazy(() =>
  import("@scenes/MessageComposition/Banner/BannerTemplateDetails").then((module) => ({
    default: module.BannerTemplateDetails,
  }))
);

export const bannerTemplateDetailsNRO: NavigationRoutingObject = {
  section: "templates",
  Component: BannerTemplateDetails,
  // This feature does not have non-NRO flow so we don't need to check for the NRO component feature flipper.
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("banner-template-details-nro-heading", "Banner Template Details"),
  pageNameForTracking: () => "Banner Template Details",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("banners") && featureOn("banners_template_library");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
